import { TabPanel } from '@mui/lab';
import { InputMoney } from '../../../../../shared/components/InputMoney';
import { Input } from '../../../../../shared/components/Input';
//import Box from '@mui/material/Box';
//import { Box } from '../../../Home/HomeStyle';

interface TabFinalizarProps {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  duploClick?: boolean;
}

export const TabFinalizar = ({
  touched,
  errors,
  values,
  handleChange,
  handleBlur,
  duploClick,
}: TabFinalizarProps) => {
  return (
    <TabPanel value={'8'}>
      <fieldset disabled={duploClick}>
        <div className={'grid grid-cols-12 pt- gap-4'}>
          <InputMoney
            disabled={true}
            label={'Total de impostos incidentes'}
            className={'col-span-3'}
            name={'finalizar.total_impostos_incidentes'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_impostos_incidentes &&
                errors?.finalizar?.total_impostos_incidentes
                ? errors?.finalizar?.total_impostos_incidentes
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_impostos_incidentes &&
                errors?.finalizar?.total_impostos_incidentes
              )
            }
            value={values?.finalizar?.total_impostos_incidentes ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total de impostos não incidentes'}
            className={'col-span-3'}
            name={'finalizar.total_impostos_nao_incidentes'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_impostos_nao_incidentes &&
                errors?.finalizar?.total_impostos_nao_incidentes
                ? errors?.finalizar?.total_impostos_nao_incidentes
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_impostos_nao_incidentes &&
                errors?.finalizar?.total_impostos_nao_incidentes
              )
            }
            value={values?.finalizar?.total_impostos_nao_incidentes ?? ''}
          />          
          <InputMoney
            disabled={true}
            label={'Total retenções serviços'}
            className={'col-span-3'}
            name={'finalizar.total_retencoes_servicos'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_retencoes_servicos &&
                errors?.finalizar?.total_retencoes_servicos
                ? errors?.finalizar?.total_retencoes_servicos
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_retencoes_servicos &&
                errors?.finalizar?.total_retencoes_servicos
              )
            }
            value={values?.finalizar?.total_retencoes_servicos ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total de impostos não incidentes serviço'}
            className={'col-span-3'}
            name={'finalizar.total_impostos_nao_incidentes_servico'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_impostos_nao_incidentes_servico &&
                errors?.finalizar?.total_impostos_nao_incidentes_servico
                ? errors?.finalizar?.total_impostos_nao_incidentes_servico
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_impostos_nao_incidentes_servico &&
                errors?.finalizar?.total_impostos_nao_incidentes_servico
              )
            }
            value={values?.finalizar?.total_impostos_nao_incidentes_servico ?? ''}
          />
          
          <Input
            disabled={true}
            label='Percentual comissão'
            name='percentual_comissao'
            className={'col-span-3'}
            value={''}
            error={undefined}
            hasError={false}
          />
          <InputMoney
            disabled={true}
            label={'Valor da comissão'}
            className={'col-span-3'}
            name={'finalizar.valor_comissao'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.valor_comissao &&
                errors?.finalizar?.valor_comissao
                ? errors?.finalizar?.valor_comissao
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.valor_comissao &&
                errors?.finalizar?.valor_comissao
              )
            }
            value={values?.finalizar?.valor_comissao ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Desconto sobre itens'}
            className={'col-span-3'}
            name={'finalizar.desconto_itens'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.desconto_itens &&
                errors?.finalizar?.desconto_itens
                ? errors?.finalizar?.desconto_itens
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.desconto_itens &&
                errors?.finalizar?.desconto_itens
              )
            }
            value={values?.finalizar?.desconto_itens ?? ''}
          />          
          <InputMoney
            disabled={true}
            label={'Desconto sobre o total (sem o desconto de itens)'}
            className={'col-span-3'}
            name={'finalizar.desconto_sobre_total'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.desconto_sobre_total &&
                errors?.finalizar?.desconto_sobre_total
                ? errors?.finalizar?.desconto_sobre_total
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.desconto_sobre_total &&
                errors?.finalizar?.desconto_sobre_total
              )
            }
            value={values?.finalizar?.desconto_sobre_total ?? ''}
          />                            

          <InputMoney
            disabled={true}
            label={'Total bruto de produtos'}
            className={'col-span-2'}
            name={'finalizar.total_bruto_produtos'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_bruto_produtos &&
                errors?.finalizar?.total_bruto_produtos
                ? errors?.finalizar?.total_bruto_produtos
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_bruto_produtos &&
                errors?.finalizar?.total_bruto_produtos
              )
            }
            value={values?.finalizar?.total_bruto_produtos ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total serviços bruto'}
            className={'col-span-2'}
            name={'finalizar.total_servicos_bruto'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_servicos_bruto &&
                errors?.finalizar?.total_servicos_bruto
                ? errors?.finalizar?.total_servicos_bruto
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_servicos_bruto &&
                errors?.finalizar?.total_servicos_bruto
              )
            }
            value={values?.finalizar?.total_servicos_bruto ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total locação bruto'}
            className={'col-span-2'}
            name={'finalizar.total_locacao_bruto'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_locacao_bruto &&
                errors?.finalizar?.total_locacao_bruto
                ? errors?.finalizar?.total_locacao_bruto
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_locacao_bruto &&
                errors?.finalizar?.total_locacao_bruto
              )
            }
            value={values?.finalizar?.total_locacao_bruto ?? ''}
          />      
          <InputMoney
            disabled={true}
            label={'Total de descontos'}
            className={'col-span-2'}
            name={'finalizar.total_descontos'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_descontos &&
                errors?.finalizar?.total_descontos
                ? errors?.finalizar?.total_descontos
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_descontos &&
                errors?.finalizar?.total_descontos
              )
            }
            value={values?.finalizar?.total_descontos ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total Frete'}
            className={'col-span-2'}
            name={'finalizar.valor_frete'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.valor_frete && errors?.finalizar?.valor_frete
                ? errors?.finalizar?.valor_frete
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.valor_frete && errors?.finalizar?.valor_frete
              )
            }
            value={values?.finalizar?.valor_frete ?? ''}
          />   
          <InputMoney            
            disabled={true}
            label={'Total líquido do pedido'}
            className={'col-span-2'}
            name={'finalizar.total_liquido_pedido'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.finalizar?.total_liquido_pedido &&
                errors?.finalizar?.total_liquido_pedido
                ? errors?.finalizar?.total_liquido_pedido
                : ''
            }
            hasError={
              !!(
                touched?.finalizar?.total_liquido_pedido &&
                errors?.finalizar?.total_liquido_pedido
              )
            }
            value={values?.finalizar?.total_liquido_pedido ?? ''}
          />
          {/* [30/09] Credito utilizado e o que sobra a receber - pedido do Deivid.

              O "Total liquido do pedido" acima NAO muda: ele e gravado como valor da
              venda (vnd_total_geral = COALESCE(total_geral, total_liquido_pedido)), e o
              valor da venda e o que sai na NOTA FISCAL. Descontar o credito ali seria a
              opcao (b), descartada - nota de mercadoria que saiu tem de sair pelo valor
              dela. O efeito do credito aparece nestes dois campos, que sao so leitura e
              nao vao para o banco.

              Alinhados sob o frete e o total, para ler de cima para baixo:
              liquido -> credito -> a receber. */}
          <InputMoney
            disabled={true}
            label={'Crédito utilizado'}
            className={'col-span-2 col-start-9'}
            name={'finalizar.credito_utilizado_exibicao'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={''}
            hasError={false}
            value={Number(values?.financeiro?.valor_credito_utilizado ?? 0).toFixed(2)}
          />
          <InputMoney
            disabled={true}
            label={'Total a receber'}
            className={'col-span-2'}
            name={'finalizar.total_a_receber_exibicao'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={''}
            hasError={false}
            value={Math.max(0,
              Number(values?.finalizar?.total_liquido_pedido ?? 0)
              - Number(values?.financeiro?.valor_credito_utilizado ?? 0)).toFixed(2)}
          />
        </div>
      </fieldset>
    </TabPanel>
  );
};
